import { useCallback, useMemo, type ReactNode } from 'react';
import { useUserConfig } from '../userConfig/useUserConfig';
import type { I18nContextValue } from '../types/i18nContext';
import { I18nContext } from './i18nContext';
import { translateForLocale } from './translate';

export function I18nProvider({ children }: { children: ReactNode }) {
  const { locale } = useUserConfig();

  const translate = useCallback(
    (key: string, values?: Record<string, string>) =>
      translateForLocale(locale, key, values),
    [locale],
  );

  const value = useMemo<I18nContextValue>(() => ({ translate }), [translate]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
